export default __webpack_public_path__ + "static/media/orange-arrow-btn.089493e7.svg";